/**
 * @generated SignedSource<<3f1060c7004d0a8e207a9c00dc3c256b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptionsQueryRenderer_viewer$data = {
  readonly userTokenCanCheckout?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_viewer" | "checkoutRelayAction_viewer" | "checkoutSetUpActionsSetUpPanes_viewer" | "usePreloadedDuties_viewer">;
  readonly " $fragmentType": "CheckoutDeliveryOptionsQueryRenderer_viewer";
};
export type CheckoutDeliveryOptionsQueryRenderer_viewer$key = {
  readonly " $data"?: CheckoutDeliveryOptionsQueryRenderer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "InlineDataFragmentSpread",
  "name": "stripeActivationHelpers_viewer",
  "selections": [
    {
      "alias": "forceStripeOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "forceStripeOn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"forceStripeOn\")"
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeCurrencies",
  "storageKey": null
},
v2 = {
  "kind": "InlineDataFragmentSpread",
  "name": "checkoutPayment_viewer",
  "selections": [
    {
      "alias": "achDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableACHCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableACHCheckout\")"
    },
    {
      "alias": "disableApplePay",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableApplePay"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableApplePay\")"
    },
    {
      "alias": "isKlarnaNegotiationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "klarnaNegotiationFlow"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Token",
      "kind": "LinkedField",
      "name": "clientToken",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "environment",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v3 = {
  "alias": "isCvcVerificationOn",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "checkoutCvcVerification"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"checkoutCvcVerification\")"
},
v4 = {
  "alias": "isStripe3dsDeluxeOn",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "stripe3DSDeluxe"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"stripe3DSDeluxe\")"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "buyerId"
    },
    {
      "kind": "RootArgument",
      "name": "hasBuyerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptionsQueryRenderer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTransactionQueryRenderer_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutRelayAction_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTransactionReducer_viewer",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrencyConversionRateEvent",
              "kind": "LinkedField",
              "name": "currentRates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutShippingReducer_viewer",
          "selections": [
            {
              "condition": "hasSessionUserGeoInfo",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RegionalInfo",
                  "kind": "LinkedField",
                  "name": "regionalInfo",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "hasSessionUserGeoInfo"
            }
          ]
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutPaymentReducer_viewer",
          "selections": [
            (v2/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreloadedDuties_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSetUpActionsSetUpPanes_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutPaneReducer_viewer",
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "condition": "hasBuyerId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "buyerId"
            }
          ],
          "kind": "ScalarField",
          "name": "userTokenCanCheckout",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "13bfdf6c811192c4925aa40d70bcf1c0";

export default node;
